import "./School.css";

const School = (props) => {
    return (<div className="school-container">
        <img className="school-image" src={props.image} alt= "404"/>
        <div className="description-box">
            <p className="school-name">{props.name}</p>
            <p className="school-degree">{props.degree}</p>
            <p className="school-year">{props.year}</p>
            <p className="grade">Grade/CGPA: {props.grade}</p>
            {props.description.map((item)=>{
                return <li>{item}</li>
            })}
        </div>
    </div>)
}

export default School;